module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  }), _vm._v(" "), _c('exampaper', {
    attrs: {
      "page": _vm.page,
      "exampaperData": _vm.exampaperData,
      "userAnswers": _vm.userAnswers,
      "showdata": _vm.showdata,
      "isShowAnswer": _vm.isShowAnswer,
      "moduleId": _vm.moduleId
    },
    on: {
      "correctScore": _vm.correctScore
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2591f5e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/checkTSMK.vue
// module id = 1165
// module chunks = 1